import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';

export const getMarketList = (
    eventModel: EventModel,
    filter: (market: MarketModel) => boolean
): Array<{letter: string, list: Array<MarketModel>}> => {
    const markets = eventModel.marketsOpen.filter(filter);

    const groups: Record<string, Array<MarketModel>> = {};

    markets
        .forEach(market => {
            const letter = market.name.substr(0, 1);

            const list = groups[letter];
            if (list === undefined) {
                groups[letter] = [market];
            } else {
                list.push(market);
            }
        });

    const marketGroups: Array<{letter: string, list: Array<MarketModel>}> = [];

    for (const [letter, list] of Object.entries(groups)) {
        marketGroups.push({
            letter,
            list
        });
    }

    marketGroups.sort((a, b): number => {
        if (a.letter > b.letter) {
            return 1;
        }

        if (a.letter < b.letter) {
            return -1;
        }

        return 0;
    });

    return marketGroups;
};
